import type { RouteLocationNormalized } from "vue-router"
import type { OtpValidateMethods, RouteMetaAuth } from "@/types/auth"
import type { HttpError } from "@/types/common"
import _split from "lodash/split"
import _toNumber from "lodash/toNumber"
import { useAuthStore } from "@/stores/auth"

export function isDebounceTimeOver(lastCheck: Date | null) {
	const debounceTime = useAuthStore().tokenDebounceTime
	return !lastCheck || lastCheck.getTime() + _toNumber(debounceTime) * 1000 < Date.now()
}

/**
 * @param expiration expiration timestamp
 * @param threshold in seconds
 */
export function isExpiring(expiration: number, threshold: number): boolean {
	try {
		return expiration ? Date.now() / 1000 > expiration - threshold : true
	} catch {
		return false
	}
}

export function authCheck(route: RouteLocationNormalized) {
	const { checkAuth, authRedirect, auth, roles }: RouteMetaAuth = route.meta
	const authStore = useAuthStore()

	if (route?.redirectedFrom?.name === "Logout") authStore.setLogout()

	const loginPath = `/login${window.location.search}`

	if (auth && (!authStore.isLogged || (roles && !authStore.isRoleGranted(roles)))) {
		window.location.replace(loginPath)
		return loginPath
	}

	if (checkAuth && authStore.isLogged) {
		return roles && !authStore.isRoleGranted(roles) ? route.path : authRedirect || "/"
	}
}

export function isOtpRequired(error: HttpError): boolean {
	for (const code of error?.codes || []) {
		if (code.includes("OTP_REQUIRED")) {
			return true
		}
	}

	return false
}

export function getOtpMethodsByError(error: HttpError): OtpValidateMethods[] {
	for (const code of error?.codes || []) {
		if (code.includes("OTP_REQUIRED")) {
			const methods = _split(code, ":")?.[1]
			if (methods) {
				return _split(methods, ",") as OtpValidateMethods[]
			}
		}
	}

	return []
}
